import { createRouter, createWebHistory } from 'vue-router';
import { ACCESS_TOKEN, CURRENT_USER } from './store/mutation-types';
import { storage } from './utils/Storage';
import { PageEnum } from './enums/pageEnum';
import { useUserStore } from './store/modules/user';
import { sendPV } from './utils/analytics';

const LOGIN_PATH = PageEnum.BASE_LOGIN;
const whitePathList = [LOGIN_PATH, '/openChatGroup', '/order', '/orderLogs', '/test'];

const routes: any[] = [
  {
    name: 'notFound',
    path: '/:path(.*)+',
    redirect: {
      name: 'home',
    },
  },
  {
    name: 'home',
    path: '/home',
    component: () => import('@/view/home/index.vue'),
    meta: {
      title: '首页',
      keepAlive: true,
    },
  },
  {
    name: 'area',
    path: '/area/:id?',
    component: () => import('@/view/area/index.vue'),
    meta: {
      title: '地区详情',
      keepAlive: true,
    },
  },
  {
    name: 'detail',
    path: '/detail/:id?',
    component: () => import('@/view/detail/index.vue'),
    meta: {
      title: '详情',
    },
  },
  {
    name: 'role',
    path: '/role/:id?',
    component: () => import('@/view/role/index.vue'),
    meta: {
      title: '角色详情',
    },
  },
  {
    name: 'search',
    path: '/search',
    component: () => import('@/view/search/index.vue'),
    meta: {
      title: '搜索',
    },
  },
  {
    path: '/',
    redirect: '/home',
  },
];

const router = createRouter({
  routes,
  history: createWebHistory(),
});

router.beforeEach((to, from, next) => {
  const title = to?.meta?.title;
  if (title) {
    document.title = title as string;
  }
  next();
});

// 路由切换后记录 PV
router.afterEach(() => {
  sendPV();
});

export default router;
